import { Button, ButtonGroup } from '@mui/material';
import { useAtom } from 'jotai';
import { currentLocaleState } from '../../atoms';

export const LocaleToggle: React.FC = () => {
  const [currentLocale, setCurrentLocale] = useAtom(currentLocaleState);

  return (
    <ButtonGroup variant="text" size="small">
      <Button
        color="inherit"
        onClick={() => setCurrentLocale('fr-CA')}
        sx={{
          textDecoration: currentLocale === 'fr-CA' ? 'underline' : 'inherit',
          fontWeight: currentLocale === 'fr-CA' ? 600 : 'inherit'
        }}
      >
        FR
      </Button>
      <Button
        color="inherit"
        onClick={() => setCurrentLocale('en-CA')}
        sx={{
          textDecoration: currentLocale === 'en-CA' ? 'underline' : 'inherit',
          fontWeight: currentLocale === 'en-CA' ? 600 : 'inherit'
        }}
      >
        EN
      </Button>
    </ButtonGroup>
  );
};
